import { useAction, useAtom } from '@reatom/npm-react'
import { useMemo } from 'react'
import styled from 'styled-components'

import { AsyncStateN } from '@blade/std-lib'
import { PremiumCurrencyInfo } from '@root/entities/premium/ui'
import { reatomPurchaseBoosters } from '@root/features/premium/purchase-boosters'
import { useOptionalAtom } from '@root/shared/lib'

import { PaymentDialogSuccess } from '../desktop/common/payment-dialog-success'
import { PaymentDrawerSuccess } from '../mobile/common/payment-drawer-success'

import { BuyBoostersForm } from './buy-boosters-form'

import type { DeviceType } from '@blade/ui-kit'
import type { CurrencyModel } from '@root/entities/currency'
import type { PremiumMetaModel } from '@root/entities/premium/atoms'

type Props = {
  currency: CurrencyModel
  premium: PremiumMetaModel | undefined
  onClose: () => void
  device: DeviceType
}

export const BuyBoosters: React.FC<Props> = ({
  currency,
  premium,
  onClose,
  device,
}) => {
  const premiumId = useOptionalAtom(premium?.premiumId)
  const model = useMemo(
    () =>
      reatomPurchaseBoosters(
        { currency, type: 'boosters', premiumId },
        'model',
      ),
    [currency, premiumId],
  )
  const [requestState] = useAtom(model.requestStateAtom)
  const reset = useAction(model.resetAction)

  const PaymentSuccess =
    device === 'mobile' ? PaymentDrawerSuccess : PaymentDialogSuccess

  return (
    <Root>
      <PremiumCurrencyInfo premium={premium} currency={currency} />
      {AsyncStateN.isSuccess(requestState) ? (
        <PaymentSuccess
          type="boosters"
          transactionHash={requestState.value.transactionHash}
          onClose={() => {
            onClose()
            reset()
          }}
        />
      ) : (
        <BuyBoostersForm model={model} currency={currency} device={device} />
      )}
    </Root>
  )
}

const Root = styled.div`
  padding: 20px 30px;
  display: grid;
  gap: 12px;
`
